var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0ZM21.8125 16C21.3681 16 20.9241 16.1576 20.585 16.4727C19.9072 17.1023 19.9072 18.1233 20.585 18.7529L27.8096 25.4648L20.5088 32.2471C19.831 32.8768 19.831 33.8977 20.5088 34.5273C21.1866 35.157 22.2851 35.157 22.9629 34.5273L31.4912 26.6045C32.169 25.9748 32.169 24.9539 31.4912 24.3242L31.4775 24.3105L23.04 16.4727C22.701 16.1576 22.2568 16.0001 21.8125 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.d963df02dd84a6efd69343576683f18f.svg";
export { ForwardRef as ReactComponent };